/*
 * Main Collection - filter tabs and pagination via the Section Rendering API.
 *
 * Swaps the filter tabs, product grid and pagination nav in place instead of a
 * full page load. Any failure falls back to normal navigation, so the links keep
 * working with JS off or a bad response.
 */
(function () {
  var BLOCK = 'oddit-section-main-collection';
  var SECTION_SELECTOR = '.' + BLOCK;
  var PARTS = ['__filters', '__grid', '__pagination'];

  function stickyHeaderHeight() {
    var header = document.querySelector('.oddit-header');
    if (!header) return 0;
    var host = header.closest('.shopify-section') || header;
    return getComputedStyle(host).position === 'sticky'
      ? header.getBoundingClientRect().height
      : 0;
  }

  function scrollToTabs(section) {
    var anchor = section.querySelector('.' + BLOCK + '__filters') || section;
    var top =
      window.pageYOffset +
      anchor.getBoundingClientRect().top -
      stickyHeaderHeight() -
      16;

    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  function render(section, url, push) {
    var target = new URL(url, window.location.origin);
    target.searchParams.set('section_id', section.id);

    fetch(target.toString())
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var next = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(SECTION_SELECTOR);
        if (!next) throw new Error('section missing');

        PARTS.forEach(function (part) {
          var current = section.querySelector('.' + BLOCK + part);
          var replacement = next.querySelector('.' + BLOCK + part);
          if (current && replacement) {
            current.replaceWith(replacement);
          } else if (current) {
            current.remove();
          }
        });

        if (push) {
          var clean = new URL(url, window.location.origin);
          clean.searchParams.delete('section_id');
          window.history.pushState({}, '', clean.pathname + clean.search);
        }

        scrollToTabs(section);
        // reuse the theme's own re-init hook for the swapped-in cards
        section.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    if (event.target.closest('a.' + BLOCK + '__filter-tab--active')) {
      event.preventDefault();
      return;
    }

    var link = event.target.closest('.' + BLOCK + '__pagination a[href]');
    if (!link) return;

    var section = link.closest(SECTION_SELECTOR);
    if (!section || !section.id) return;

    event.preventDefault();
    render(section, link.href, true);
  });

  window.addEventListener('popstate', function () {
    var section = document.querySelector(SECTION_SELECTOR);
    if (section && section.id) render(section, window.location.href, false);
  });
})();
